"use client";
import { jsxs, jsx } from "react/jsx-runtime";
import { ColorRed500 } from "@nxt-costco-com/forge-design-tokens";
import { CaptionDiscalimerSection } from "./CaptionDisclaimerSection.js";
import { FeatureTilesSection } from "./FeatureTilesSection.js";
import { Header } from "./Header.js";
import { TextSection } from "./TextSection.js";
import { VIEW_NAME_FEATURE } from "./constants.js";
import { getLargeViewportOrientation } from "./lib.js";
import { DEFAULT_FEATURE_TEXT_COLOR, CardContainer, CardBody } from "./styles.js";
function FeatureCard({ data }) {
  if (!data) {
    return null;
  }
  const { background_color, text_color } = data.body_section_config.text_and_background_color;
  const background = (background_color == null ? void 0 : background_color.hex) || ColorRed500;
  const color = (text_color == null ? void 0 : text_color.hex) || DEFAULT_FEATURE_TEXT_COLOR;
  const { tiles_button_dynamic_row_config } = data;
  const {
    content_alignment,
    large_viewport_image_orientation,
    large_viewport_orientation
  } = tiles_button_dynamic_row_config ?? {};
  const largeViewportFlexDirection = getLargeViewportOrientation(
    large_viewport_orientation,
    large_viewport_image_orientation
  );
  return /* @__PURE__ */ jsxs(
    CardContainer,
    {
      "data-testid": VIEW_NAME_FEATURE,
      largeViewportFlexDirection,
      children: [
        data.use_header_section && /* @__PURE__ */ jsx(
          Header,
          {
            data,
            largeViewportFlexDirection,
            viewName: VIEW_NAME_FEATURE
          }
        ),
        /* @__PURE__ */ jsxs(CardBody, { background, color, children: [
          /* @__PURE__ */ jsx(
            TextSection,
            {
              contentAlignment: content_alignment,
              data,
              globalTextColor: color,
              viewName: VIEW_NAME_FEATURE
            }
          ),
          /* @__PURE__ */ jsx(
            FeatureTilesSection,
            {
              data,
              globalTextColor: color,
              viewName: VIEW_NAME_FEATURE
            }
          ),
          /* @__PURE__ */ jsx(
            CaptionDiscalimerSection,
            {
              contentAlignment: content_alignment,
              data,
              globalTextColor: color,
              viewName: VIEW_NAME_FEATURE
            }
          )
        ] })
      ]
    }
  );
}
export {
  FeatureCard
};
